import { useIsInSuspense } from '@pbk-web/state';
import type { FCWithChildren } from '@pbk-web/types';
import { useEffect } from 'react';

import Loader from './Loader';

type PageLoaderProps = {
  loading: boolean;
  isSuspense?: boolean;
  loaderSize?: number;
};

const PageLoader: FCWithChildren<PageLoaderProps> = (props) => {
  const { loading, isSuspense, loaderSize = 32, children } = props;

  const setIsInSuspense = useIsInSuspense((x) => x.setValue);

  useEffect(() => {
    if (isSuspense) {
      setIsInSuspense(true);

      return () => {
        setIsInSuspense(false);
      };
    }
  }, [isSuspense, setIsInSuspense]);

  useEffect(() => {
    const html = document.querySelector('html') as HTMLElement;
    if (loading) {
      html.dataset.cy = 'contains-loader';
    } else {
      delete html.dataset.cy;
    }

    return () => {
      delete html.dataset.cy;
    };
  }, [loading]);

  if (loading) {
    return (
      <div
        // style because tailwind's css might not have loaded yet
        style={{
          width: '100%',
          height: '100%',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999,
        }}
        data-testid="page-loader"
      >
        <Loader size={loaderSize} />
      </div>
    );
  }

  return children;
};

export default PageLoader;
